import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.ROOT_API,
});

instance.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`;

export default instance;



// WEBPACK FOOTER //
// ./src/axios.js